import React from 'react';
import { Checkbox, Form, Header } from 'semantic-ui-react';
import { openRouterConfigV1015 } from './openrouterConfigV1015';
import './openrouterV1015.css';

export default function OpenRouterRoutingV1015({ type, config, onChange, t }) {
  if (Number(type) !== 20) return null;
  const policy = openRouterConfigV1015(config);
  const text = (key) => t(`channel.edit.openrouter_v1015.${key}`);
  const change = (key, value) =>
    onChange(null, {
      name: 'openrouter_v1015',
      value: { ...policy, [key]: value },
    });
  return (
    <section className='openrouter-routing-v1015' aria-label={text('title')}>
      <Header as='h4'>{text('title')}</Header>
      <Form.Field>
        <Checkbox toggle label={text('enabled')} checked={policy.enabled}
          onChange={(_, { checked }) => change('enabled', checked)} />
      </Form.Field>
      {policy.enabled && (
        <>
          <Form.Select
            id='openrouter-mode-v1015'
            label={text('mode')}
            value={policy.mode}
            options={['default', 'price', 'floor'].map((mode) => ({
              key: mode, value: mode, text: text(mode),
            }))}
            onChange={(_, { value }) => change('mode', value)}
          />
          <div className='openrouter-switches-v1015'>
            {['require_parameters', 'allow_fallbacks'].map((key) => (
              <Form.Field key={key}>
                <Checkbox label={text(key)} checked={policy[key]}
                  onChange={(_, { checked }) => change(key, checked)} />
              </Form.Field>
            ))}
          </div>
          <Header as='h5'>{text('ceilings')}</Header>
          <div className='openrouter-ceilings-v1015'>
            {['prompt', 'completion', 'request', 'image'].map((meter) => (
              <Form.Input
                key={meter} id={`openrouter-${meter}-v1015`}
                label={text(meter)} value={policy.max_price[meter] ?? ''}
                placeholder={text('unlimited')} inputMode='decimal'
                autoComplete='off'
                onChange={(_, { value }) =>
                  change('max_price', { ...policy.max_price, [meter]: value })}
              />
            ))}
          </div>
        </>
      )}
    </section>
  );
}
